module.exports = __webpack_public_path__ + "img/series_btn.4c5a0e64.png";